export default __webpack_public_path__ + "landlord.zh-cn.1762504472222.json";